var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7528 11.1977C21.6111 9.73547 21.9919 8.03165 21.82 6.30937C21.5656 3.77425 20.1502 1.53329 17.8368 0L16.2666 2.36743C17.8567 3.42184 18.8244 4.92387 18.9921 6.59357C19.1484 8.16381 18.5942 9.71131 17.4688 10.8368L15.7749 12.5306L18.0741 13.2056C24.0879 14.9677 24.1576 21.0156 24.1576 21.0767H26.9996C26.9996 18.5345 25.6411 13.5666 20.7528 11.1977Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99976,
    cy: 7.34229,
    r: 4,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6577 12.5504C13.7925 12.5504 16.3418 10.001 16.3418 6.86624C16.3418 3.73145 13.7925 1.18213 10.6577 1.18213C7.52293 1.18213 4.9736 3.73145 4.9736 6.86624C4.9736 10.001 7.52293 12.5504 10.6577 12.5504ZM10.6577 4.02419C12.2251 4.02419 13.4998 5.29885 13.4998 6.86624C13.4998 8.43364 12.2251 9.7083 10.6577 9.7083C9.09032 9.7083 7.81566 8.43364 7.81566 6.86624C7.81566 5.29885 9.09032 4.02419 10.6577 4.02419ZM12.7893 13.9714H8.52617C3.82399 13.9714 0 17.7954 0 22.4976V23.9186H2.84206V22.4976C2.84206 19.3628 5.39138 16.8134 8.52617 16.8134H12.7893C15.924 16.8134 18.4734 19.3628 18.4734 22.4976V23.9186H21.3154V22.4976C21.3154 17.7954 17.4914 13.9714 12.7893 13.9714Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/Employees.8d5a052a.svg";
export { ForwardRef as ReactComponent };